import { render, staticRenderFns } from "./SubmittedDisputeModal.vue?vue&type=template&id=5d197a64&scoped=true&"
import script from "./SubmittedDisputeModal.vue?vue&type=script&lang=js&"
export * from "./SubmittedDisputeModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmittedDisputeModal.vue?vue&type=style&index=0&id=5d197a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d197a64",
  null
  
)

export default component.exports